export default {
	legacy: false,
	locale: "en",
	messages: {
		en: {
			//TODO: Maintain Alphabetical order!!!
			accept: "Accept",
			addedToCart: "Added",
			addOn: "Add-On",
			addOns: "Add-Ons",
			addToCart: "Add To Cart",
			apply: "Apply",
			back: "Back",
			backToBeginning: "Back to Beginning",
			billingFirstName: "Billing First Name",
			billingInformationSubtitle: "Enter the billing information associated with the card below.",
			billingInformationTitle: "Billing Information",
			billingLastName: "Billing Last Name",
			buyNow: "Buy Now",
			cardCVVCode: "CVV Code",
			cardCvvPlaceholder: "CVV",
			cardExpirationDate: "Expiration Date",
			cardExpiryDatePlaceholder: "MM / YY",
			cardNumber: "Card Number",
			cartTimeoutBody: "Your cart has expired and your cart items were removed from your cart. We hope to see you on the Dancefloor!",
			cartTimeoutCountdown: "Your items will be held for {time}",
			cartTimeoutTitle: "Uh Oh, Your Cart Expired!",
			cartTimeoutWarningBody: "Your cart is about the expire and your cart items will no longer be held. Would you like {minutes} more minutes?",
			cartTimeoutWarningTitle: "Warning!",
			checkout: "Checkout",
			checkoutBillingTo: "Billing To:",
			checkoutOrderConfirmation: "Order Confirmation",
			checkoutOrderContact: "Order Contact:",
			checkoutOrderDate: "Order Date:",
			checkoutOrderNumber: "Order Number:",
			checkoutPaymentType: "Payment Type:",
			checkoutCardNumber: "Card Number:",
			checkoutPageError: "Some of your payment information is incorrect or missing. Please double check your data and resubmit your order. If the problem persists, try a different browser or call our support team.",
			checkoutPrice: "Price",
			checkoutProduct: "Product",
			checkoutQuantity: "Quantity",
			checkoutQuantityAbbreviated: "Qty",
			checkoutShippingTo: "Shipping To:",
			clearCart: "Clear Cart",
			close: "Close",
			confirmation: "Confirm",
			contactAndShippingSubtitle: "Please provide contact and shipping details for this order.",
			contactAndShippingTitle: "Contact & Shipping Information",
			continue: "Continue",
			cookiesNotice: "Our site uses analytical tools to help make your experience better. We’d love to have you" +
				" accept our cookies but we’ll always respect your data choices. Some cookies are necessary for our page to work.",
			couponFieldLabel: "Apply Code",
			couponFieldPlaceholder: "Enter Code",
			couponFieldTooltip: "Add at least one item to your cart. Then fill out the Shipping First Name, Shipping Last Name and Shipping Email to apply a code to your order.",
			decline: "Decline",
			detectedTranslatorBody: "We've detected that you are using a translator. While you are welcome to continue, please note that translations have caused issues for some users. If you experience any errors or problems, we recommend switching back to English for the best experience.",
			detectedTranslatorTitle: "Translator Detected",
			disabledCheckout: "We have disabled the checkout functionality. You can still browse the site and build a cart.",
			discounts: "Discount(s)",
			discoverMore: "Discover More",
			donation: "Donation",
			donations: "Donations",
			dropdownPlaceholder: "Select",
			edit: "edit",
			ellipsis: "...",
			emptyCart: "You have no items in your cart",
			errorPageBody: "Sorry about that, we are working to fix the issue.",
			errorPageMissingBody: "The page you are looking for does not exist",
			errorPageMissingTitle: "Not Found",
			errorPageTitle: "Oops! Something went wrong!",
			errorPopupDefaultBody: 'Error!',
			errorPopupDefaultTitle: 'Error!',
			errorPopupRefresh: "Sorry about that, we are working to fix the issue. Please refresh your browser.",
			errorPopupTerms: "Unable to fetch the terms and conditions. If the problem persists, please contact support.",
			fetchingProducts: "Fetching Products...",
			firstName: "First Name",
			gst: "GST",
			helpShow: "Show Help",
			helpHide: "Hide Help",
			hideDetails: "Hide Details",
			homepageBody_addOns: 'Take a look at some of our Add-Ons. If none of them tickle your fancy, click "Next" to skip.\n\n',
			homepageBody_checkout: "We can't wait to see you on the dancefloor!\n\n",
			homepageBody_confirmation: "A confirmation email has been sent to {email}.\nWe will send you an additional email once your order has been processed.",
			homepageBody_donations: 'Please consider donating to some of our amazing partners.',
			homepageBody_lodging: 'Select your desired lodging experience. If you already have a place to \nstay, use the icons above to navigate or click "Next" to skip.',
			homepageBody_merch: 'Discover exclusive accessories to complement your purchase and maximize its potential.\n\n',
			homepageBody_shuttles: "Don't want to drive? Hitch a ride on one of our shuttles.",
			homepageBody_tickets: 'Select and add tickets to your cart. If you already have tickets, right on!\nUse the icons above to navigate or click "Next" to skip.',
			homepageHeading_addOns: "Interested in some upgrades?",
			homepageHeading_checkout: "All set? Let's get you checked out.",
			homepageHeading_confirmation: "Thanks for your order {name}!",
			homepageHeading_donations: "Donations",
			homepageHeading_lodging: "Choose your Lodging Package!",
			homepageHeading_merch: "Pick up some Merch",
			homepageHeading_shuttles: "Need a ride?",
			homepageHeading_tickets: "Let's get you some tickets!",
			installmentsNote: "Note: The following items are not eligible for payment plans. These items will be included and paid in full with your first payment.",
			installmentsNotEligible: "None of your items are eligible",
			installmentsOf: "Payment 1 of {numInstallments}",
			invalidAddress1: "Please enter a valid address",
			invalidCardNumber: "Please enter a valid credit card number",
			invalidCity: "Please enter a valid city",
			invalidCountry: "Please enter a valid country",
			invalidCVV: "Please enter a valid cvv",
			invalidEmail: "Please double check the email(s) entered",
			invalidExpiryDate: "Please enter a valid expiry date",
			invalidFirstName: "Please enter a valid first name",
			invalidLastName: "Please enter a valid last name",
			invalidPhone: "Please enter a valid phone number",
			invalidPostalCode: "Please enter a valid Postal Code",
			invalidProvince: "Please enter a valid Province",
			invalidState: "Please enter a valid State",
			invalidZipcode: "Please enter a valid Zip Code",
			leaveSiteBtn: "Back to Site",
			lodging: "Lodging",
			loginPageBody: "The site is only available to system administrators right now.",
			loginPageTitle: "Welcome to the {eventName} Ticket Portal",
			loremIpsumLong: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
			loremIpsumShort: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
			maintenance1: "Sorry, we're down for scheduled maintenance right now.",
			maintenance2: "We apologize for any inconveniences",
			maintenanceBtn: "Continue Wandering",
			maxReachedBody: "You may not exceed a maximum of: {max} units per order for this product.",
			maxReachedTitle: "Maximum Limit Reached",
			merch: "Merch",
			miniCartCoupons: "Apply Codes during Checkout.",
			miniCartSubtitle: "Here's what we currently have in your cart.",
			miniCartTitle: "Cart Summary",
			newsAndUpdates: "I would like to receive news and updates from {eventName}",
			next: "Next",
			no: "No",
			noCartExists: "Empty Cart",
			noCartItemsBody: "Please add something to your cart before performing this action. If you are experiencing problems, please contact our support team.",
			noCartItemsForOrder: "Please add something to your cart before placing an order",
			noCartItemsTitle: "No Cart Items",
			noInternet: "You're Offline",
			noInternetBody: "You have no internet connection right now. Please find a stronger internet connection or try refreshing the page.",
			noLodgingItem: "Please add a lodging item",
			nonRefundable: "Non-Refundable",
			noRefundableItems: "None of your items are refundable",
			noRefundableMinimum: "This cart does not qualify for refundable booking protection",
			noTicketsPopupBody: "You need a ticket to attend, are you sure you wish to continue without one?",
			noTicketsPopupTitle: "You have no tickets",
			ok: "ok",
			orderPlacedPopupBody: "You will receive a confirmation email shortly.\nWe will send you an additional email once your order has been processed.",
			orderPlacedPopupTitle: "Thanks for your order!",
			orderSummaryPrices: "All prices shown below are in {currencyName}.",
			orderSummarySubtitle: "Here's what we currently have in your cart.",
			orderSummaryTitle: "Order Summary",
			paymentDue: "Payment Due: {date}",
			paymentInstalments: "Payments",
			paymentInstalmentsSubtitle: "Pay for your order with monthly payments.\nPayments are non-refundable.",
			paymentMethodSubtitle: "Enter the credit card details for this order.",
			paymentMethodTitle: "Payment Method",
			person: "Person",
			phoneTooltip: "Type an alternative phone number by entering a plus symbol (+) and your country code, the flag icon will indicate if you have correctly entered your number.",
			placeOrder: "Submit",
			plusTax: "Plus Tax",
			poorConnectionBody: "You've been lost in the crowd. Please try to find a stronger internet connection.",
			poorConnectionTitle: "Poor Connection Detected",
			previewProductComparison: "Product Comparison",
			previewProductComparisonInfo: "This table compares all of your products.",
			previewProductComparisonLink: "Compare Products",
			previewSiteMap: "Site Map",
			previewSiteMapInfo: "This map shows the layout of our site.",
			previewSiteMapLink: "View Site Map",
			previewHelpDesktop: "<div>\n" +
				"    <ul>\n" +
				"        <li>Zoom in: Ctrl+Scroll (PC), or CMD+Scroll (Mac).</li>\n" +
				"        <li>Pan around: Click-hold and drag.</li>\n" +
				"    </ul>\n" +
				"</div>",
			previewHelpMobile: "<div>\n" +
				"    <ul>\n" +
				"        <li>Zoom in: Pinch/Spread with two-fingers.</li>\n" +
				"        <li>Pan around: Touch and drag with one finger.</li>\n" +
				"    </ul>\n" +
				"</div>",
			proceed: "Proceed",
			processing: "Fees",
			productImagesTitle: "Gallery",
			pst: "PST",
			recommended: "(Recommended)",
			refresh: "Refresh",
			refundable: "Refundable",
			refundableBooking: "Refundable Booking",
			refundableBookingCardTitle: "Refundable Booking",
			refundableBookingCardSubtitle: "Be prepared for the unexpected.",
			refundableInfoBody1: "Select Refundable Booking and receive a refund on select items if you are unable to attend the event due to any of the listed reasons below. Required evidence must be shown. Subject always to the General Conditions of Refund.",
			refundableInfoMore1: "For more information, see",
			refundableInfoMore2: "Terms and Conditions",
			refundableInfoReason1a: "Covid-19 Infection,",
			refundableInfoReason1b: "See Details",
			refundableInfoReason2: "Sickness, Accident, Injury",
			refundableInfoReason3: "Public Transport Failure",
			refundableInfoReason4: "Private Vehicle Failure",
			refundableInfoReason5: "Emergency Services Recall",
			refundableInfoReason6: "Home Emergency",
			refundableInfoReason7: "Immediate Relative Sickness",
			refundableInfoReason8: "Pre-existing Medical Condition",
			refundableInfoReason9: "And Many More...",
			refundableInfoTitle: "Refundable Booking Details",
			refundableItems: "Note: Only the following items are refundable and will be charged the refundable booking fee.",
			removeItem: "Remove Item",
			reserved: "Reserved",
			reservedNow: "Reserve Now",
			sameBillingAndShipping: "Billing and Shipping Information are the same",
			search: "Search",
			seatsIoErrorPopupBody: "Your item is secure in your cart, and your spot is guaranteed! <br/><br/>However, we are unable to save your preferred location at the moment, but we are working to resolve this promptly. You may still proceed to checkout.",
			seatsIoErrorPopupTitle: "Oops!",
			seatsIoLabel: "[b]Site ID: [/b] {id}",
			seatsIoPopupAutoReserve: "Auto-book {qty} spot(s)",
			seatsIoPopupHelp: "Use the map to find and select your spot(s). Click the 'Auto-Book' button and we will book the best available spots for you.",
			seatsIoPopupList: "You are eligible to reserve",
			seatsIoPopupListRemove: "Please remove",
			seatsIoPopupMapHelpDesktop: "<ul>\n" +
				"    <li>Zoom in: Ctrl+Scroll (PC), or CMD+Scroll (Mac) until the site numbers appear. Or double-click.</li>\n" +
				"    <li>Pan around: Click-hold and drag.</li>\n" +
				"    <li>Check site availability: Hover over a site number to view its status. Click the site number to reserve it. Greyed out sites are already booked or on hold.</li>\n" +
				"</ul>",
			seatsIoPopupMapHelpMobile: "<ul>\n" +
				"    <li><strong>Zoom in:</strong> Pinch/Spread with two-fingers, until the site numbers appear</li>\n" +
				"    <li><strong>Pan around:</strong> Touch and drag with one finger</li>\n" +
				"    <li><strong>Check site availability:</strong> Click on a site number and click \"SELECT\" in the popup to reserve the site. Greyed out sites are already booked or on hold</li>\n" +
				"</ul>",
			seatsIoPopupTitle: "Reserve your Spot",
			seatsIoPopupTitleRemove: "Un-select a Spot",
			seatsIoPreviewHelp: "This interactive map shows the live status of our reserved camping areas. To reserve a site, add it to your cart and confirm your selection. Greyed out sites are already booked or on hold.",
			seatsIoPreviewHelpDesktop: "<div>\n" +
				"    <ul>\n" +
				"        <li>Zoom in: Ctrl+Scroll (PC), or CMD+Scroll (Mac) until the site numbers appear. Or double-click.</li>\n" +
				"        <li>Pan around: Click-hold and drag.</li>\n" +
				"        <li>Check site availability: Hover over a site number to view its status.</li>\n" +
				"    </ul>\n" +
				"</div>",
			seatsIoPreviewHelpMobile: "<div>\n" +
				"    <ul>\n" +
				"        <li>Zoom in: Pinch/Spread with two-fingers, until the site numbers appear.</li>\n" +
				"        <li>Pan around: Touch and drag with one finger.</li>\n" +
				"        <li>Check site availability: Click on a site number to view its status.</li>\n" +
				"    </ul>\n" +
				"</div>",
			seatsIoPreviewLink: "Click here to view map",
			seatsIoPreviewTitle: "Sites / Tents Map",
			serverError: "Server Error",
			serverErrorUnhandled: "{msg}. Please contact customer service to resolve the issue.",
			shippingAddress1: "Address",
			shippingAddress2: "Address 2",
			shippingCity: "City",
			shippingCountry: "Country",
			shippingEmail: "Email",
			shippingEmailConfirm: "Confirm Email",
			shippingFirstName: "First Name",
			shippingLastName: "Last Name",
			shippingPhone: "Phone",
			shippingPostalCode: "Postal Code",
			shippingProvince: "Province",
			shippingState: "State",
			shippingZipcode: "Zip Code",
			shuttle: "Shuttle",
			shuttles: "Shuttles",
			signatureLabel: "Sign Here:",
			signatureClear: "Clear Signature",
			siteNotificationMsg: "This is the site notification banner. Update this message for the client.",
			stagingSiteWarning: "This is our testing site. Orders placed on this site are NOT valid and will NOT be honored.",
			soldOut: "Sold Out",
			soldOutAPIResponse: "This item is unavailable. Please be patient as abandoned carts replenish inventory.",
			soldOutLink1: "Join Waitlist",
			soldOutLink2: "Join Waitlist",
			soldOutTooltip: "*Please note: when the button says ‘Unavailable’, all items are currently in carts. Please be patient as abandoned carts replenish inventory.",
			stay: "Stay",
			subtotal: "Subtotal",
			sunday: "Sunday Sales",
			sundays: "Sunday Sales",
			termsAndConditions: "Terms & Conditions",
			ticket: "Ticket",
			tickets: "Tickets",
			total: "Total",
			totalDue: "Total Due Today",
			totalRemaining: "Total Remaining",
			tryAgain: "Try Again!",
			unavailable: "Unavailable",
			viewDetails: "View Details",
			volunteer: "Volunteer Deposits",
			volunteers: "Volunteer Deposits",
			xMoreMinutes: "{minutes} More Minutes!",
			yes: "Yes",
		},
		fr: {},
	},
}
